module.exports = __webpack_public_path__ + "media/images/mercy-health-82e5a9fbf9f9914637e9a4980a5716e2.png";